import { getApplePayValidation } from '@/services/api';

const supportedNetworks =
  process.env.APPLE_PAY_SUPPORTED_NETWORKS?.split(',') || [];
const merchantCapabilities =
  process.env.APPLE_PAY_MERCHANT_CAPABILITIES?.split(',') || [];
const merchantIdentifier = process.env.APPLE_PAY_MERCHANT_ID || '';

interface UseApplePayOptions {
  totalPrice: number;
  paymentLinkId: string;
  onPaymentAuthorized: (paymentData: any) => Promise<void>;
}

export default async function useApplePay({
  totalPrice,
  paymentLinkId,
  onPaymentAuthorized,
}: UseApplePayOptions) {
  return new Promise((resolve, reject) => {
    try {
      const ApplePaySession = window.ApplePaySession;

      const paymentRequest = {
        countryCode: 'BR',
        currencyCode: 'BRL',
        merchantIdentifier,
        total: {
          label: 'Blu',
          amount: totalPrice.toFixed(2),
          type: 'final',
        },
        supportedNetworks,
        merchantCapabilities,
      };

      const session = new ApplePaySession(3, paymentRequest);

      session.oncancel = () => {
        reject(new Error('Pagamento cancelado pelo usuário'));
      };

      session.onvalidatemerchant = async (event: any) => {
        try {
          const merchantValidationResponse = await getApplePayValidation(
            paymentLinkId,
            event.validationURL,
          );

          session.completeMerchantValidation(merchantValidationResponse.data);
        } catch (err) {
          session.abort();
          reject(err);
        }
      };

      session.onpaymentauthorized = async (event: any) => {
        try {
          console.log('payment authorized', event);
          const payment = event.payment;

          // Call the callback to submit the checkout
          await onPaymentAuthorized(payment);

          session.completePayment(ApplePaySession.STATUS_SUCCESS);
          resolve({
            paymentMethodData: payment,
          });
        } catch (err) {
          console.error('Erro no processamento do pagamento:', err);
          session.completePayment(ApplePaySession.STATUS_FAILURE);
          reject(err);
        }
      };

      session.begin();
    } catch (error) {
      window.alert(`Erro ao iniciar Apple Pay: ${error}`);
      reject(error);
    }
  });
}
